import React from "react";
import { useEffect, useState } from "react";
import { Select, Skeleton } from "antd";
import dayjs from "dayjs";

import { useDispatch, useSelector } from "react-redux";

import { useGetClientDropdownsQuery } from "../redux/api/adsReporting";
import {
  setStartAndEndDate,
  setSelectedClient,
  setIsAutoCompareDates,
} from "../redux/store/genericReportingSlice";
import DateGranularityDropdown from "../components/UI/DateGranularityDropdown";
import "../containers/containerStyles.css";
import CompareDateRangeDatePicker from "../components/UI/CompareDateRangeDatePicker";
import DateRangePicker from "../components/UI/DateRangePicker";
import DropdownContainer from "../containers/DropdownContainer";
import ClientRegionDropdown from "../components/UI/ClientRegionDropdown";
import SingleClientRegionDropdown from "../components/UI/SingleClientRegionDropdown";

import TooltipContainer from "../components/UI/TooltipContainer";

import { useCookies } from "react-cookie";

export const GenericReportingDropdowns = ({
  includeDateRange = true,
  includeRegion = true, 
  includeSingleSelectRegion = false,
  includeGranularity = false,
  extraDropdowns = [],
  includeTooltips = false,
  includeTitles = true,
  includeCompareDateRange = false,
  includeMarketingBreakdown = false,
}) => {
  const dispatch = useDispatch();
  const selectedClient = useSelector(
    (state) => state.genericReporting.selectedDropdownValues['client_name']
  );
  const selectedStartDate = useSelector(
    (state) => state.genericReporting.selectedDropdownValues['start_date']
  );
  const selectedEndDate = useSelector(
    (state) => state.genericReporting.selectedDropdownValues['end_date']
  );
  const jwtToken = useSelector((state) => state.oauth.auth0Token);

  const [cookies, setCookie] = useCookies(["selectedClient"]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (cookies.selectedClient && !selectedClient) {
      dispatch(setSelectedClient(cookies.selectedClient));
    }
    else if (selectedClient) {
      setCookie("selectedClient", selectedClient, { path: "/" });
    }

    }, [cookies.selectedClient, dispatch, selectedClient]);

  useEffect(() => {
    if (!selectedStartDate || !selectedEndDate) {
      dispatch(
        setStartAndEndDate([
          dayjs().subtract(1, "month").subtract(1, "day").format("YYYY-MM-DD"),
          dayjs().subtract(1, "day").format("YYYY-MM-DD"),
        ])
      );
    }
  }, [dispatch, selectedStartDate, selectedEndDate]);

  return (
    <div>
      <div
        style={{
          borderRadius: "var(--co-radius)",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "left",
          alignContent: "left",
          alignSelf: "left",
          animation: "fadeIn 1.5s",
          // marginBottom: "1.5vh",
          // marginTop: "1.2vh",
        }}
      >
        <div>
          <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "center", alignItems: "flex-end", rowGap: "1vw" }}>
              <div>
                {includeTooltips && (
                  <TooltipContainer
                    style={{
                      alignSelf: "flex-end",
                      margin: "0",
                      width: "0.8vw",
                      height: "1.0vh",
                    }}
                    invertColor={true}
                    title="Account"
                  />
                )}
                <DropdownContainer dropdown_name="client_name" extraApiParams={{
                  jwt_token: jwtToken
                }} />
              </div>
            {includeRegion && !includeSingleSelectRegion && (
              <div>
                <ClientRegionDropdown />
              </div>
            )}
            {includeSingleSelectRegion && (
              <div>
                <SingleClientRegionDropdown />
              </div>
            )}
            {includeDateRange && (
              <div style={{ marginLeft: "0.5vw", marginRight: "0.5vw" }}>
                {includeTitles && <h4>Date Range</h4>}
                {includeTooltips && (
                  <TooltipContainer
                    style={{
                      alignSelf: "flex-end",
                      margin: "0",
                      width: "0.8vw",
                      height: "1.0vh",
                    }}
                    invertColor={true}
                    title="Date Range"
                  />
                )}
                <DateRangePicker onOpenChange={setOpen} />
              </div>
            )}
            {includeGranularity && (
                <DateGranularityDropdown />
            )}
            {includeCompareDateRange && (
              <div style={{ marginLeft: "0.5vw", marginRight: "0.5vw" }}>
                {includeTitles && <h4>Compare Date Range</h4>}
                {includeTooltips && (
                  <TooltipContainer
                    style={{
                      alignSelf: "flex-end",
                      margin: "0",
                      width: "0.8vw",
                      height: "1.0vh",
                    }}
                    invertColor={true}
                    title="Compare Date Range"
                  />
                )}
                <CompareDateRangeDatePicker />
              </div>
            )}
            {includeMarketingBreakdown && (
              <DropdownContainer dropdown_name="breakdown" />
            )}
            {extraDropdowns}
          </div>
        </div>
      </div>
    </div>
  );
};
